import React from "react";

export default {
    'en_CA': 'English (Canada)',
    'en_US': 'English (United States)',
    'en_GB': 'English (Great Britain)',
    'fr_CA': 'French (Canada)',
    'fr_FR': 'French (France)',
	'fr_BE': 'French (Belgium)',
	'fr_MA': 'French (Morocco)',
    'pt_PT': 'Portuguese (Portugal)',
	'el_GR': 'Greek (Greece)',
	'es_ES': 'Spanish (Spain)',
	'es_MX': 'Spanish (Mexico)',
	'es_CO': 'Spanish (Colombia)',
	'nl_BE': 'Dutch (Belgium)',
	'pt_BR': 'Portuguese (Brazil)',
	'sk_SK': 'Slovak (Slovakia)',
	'sr_RS': 'Serbian (Serbia)',
	'tr_TR': 'Turkish (Turkey)',
    'fi_FI': 'Finnish (Finland)',
    'sv_SE': 'Swedish (Sweden)',
    // GAME_SUSPENDED_MESSAGE: 'Game {0} is currently suspended...',  {0} = game name EXAMPLE WITH WILD CARD market types
    WIN_DRAW_WIN: 'Výsledok zápasu',
    CORRECT_SCORE: 'Presné skóre',
    TOTAL_GOALS: 'Celkový počet gólov',
    DOUBLE_CHANCE: 'Dvojtip',
    UNDER_OVER: 'Nad/Pod',
    UNDER_OVER_25: 'Nad/Pod 2,5',
    UNDER_OVER_25_INITIALS: 'Nad/Pod 2,5',
    UNDER_OVER_35_INITIALS: 'Nad/Pod 3,5',
    UNDER_OVER_15: 'Nad/Pod 1,5',
    ASIAN_HANDICAP: 'Ázijský handicap',
    HANDICAP:'1X2 Handicap',
    HANDICAP_FIRST : '1X2 Handicap Home +1',
    HANDICAP_SECOND : '1X2 Handicap Away +1',
    UNDER_OVER_05: 'Nad/Pod 0,5',
    UNDER_OVER_35: 'Nad/Pod 3,5',
    BOTH_TEAMS_SCORE: 'Oba tímy skórujú',
    BOTH_TEAMS_SCORE_INITIALS: 'OTS',
    HOME_TEAM_GOALS: '{0} Góly tímu',
    AWAY_TEAM_GOALS: '{1} Góly tímu',
    MATCH_BETTING_BOTH_TEAMS_SCORE: 'Stávka - oba tímy v zápase skórujú',
    WINNING_MARGIN: 'Víťazný rozdiel',
    CORRECT_SCORE_GROUP: 'Skupina presného skóre',
    HOME_TEAM_TO_SCORE: '{0} skóruje',
    AWAY_TEAM_TO_SCORE: '{1} skórujú',
    FIRST_TEAM_TO_SCORE: 'Ako prvý skóruje tím',
    LAST_TEAM_TO_SCORE: 'Ako posledný skóruje tím',
    HALF_TIME_FULL_TIME: 'Polčas / Konečný výsledok',
    TEAM_SCORECAST: 'Tímové skóre',
    HALF_TIME_CORRECT_SCORE: 'Presné skóre 1. polčasu',
    HALF_TIME_RESULT: 'Výsledok po 1. polčase',
    FIRST_LAST_TO_SCORE: 'Prvý/posledný, ktorý skóruje',
    LAST: 'Posledný',
    FIRST: 'Prvý',
    IN: 'v',
    LAST_THREE_GAMES: 'Ostatné 3 zápasy',
    PREVIOUS: 'Predchádzajúcich',
    EIGHT_RESULTS: '8 zápasov',
    EIGHT_GAMES: '8 zápasov',
    OVER_25: 'Nad 2,5',
    UNDER_25: 'Pod 2,5',
    OVER_35: 'Nad 3,5',
    UNDER_35: 'Pod 3,5',
    COVERED: 'HCP Pokrytý',
    DID_NOT_COVER: 'HCP Nepokrytý',
    SPREAD: 'Handicap',
    TOTAL_POINTS_UNDER_OVER: 'Celkový počet bodov N/P',
    TOTAL_POINTS_OVER_UNDER: 'Celkový počet bodov N/P',
    MONEYLINE: 'Víťaz',
    TOTAL_POINTS_GROUP: 'Skupina celkového počtu bodov',
    MONEY_LINE_TOTAL_POINTS: 'Víťaz a celkový počet bodov N/P',
    SPREAD_TOTAL_POINTS: 'Handicap a celkový počet bodov N/P',
    // countries (these are lowecase and strings on purpose)
    'Argentina': 'Argentína',
    'Belgium': 'Belgicko',
    'Brazil': 'Brazília',
    'Colombia': 'Kolumbia',
    'Costa Rica': 'Kostarika',
    'Croatia': 'Chorvátsko',
    'Czech Republic': 'Česká republika',
    'Denmark': 'Dánsko',
    'Egypt': 'Egypt',
    'England': 'Anglicko',
    'France': 'Francúzsko',
    'Germany': 'Nemecko',
    'Greece': 'Grécko',
    'Holland': 'Holandsko',
    'Iceland': 'Island',
    'Italy': 'Taliansko',
    'Mexico': 'Mexiko',
    'Poland': 'Poľsko',
    'Portugal': 'Portugalsko',
    'Republic of Ireland': 'Írska republika',
    'Russia': 'Rusko',
    'Spain': 'Španielsko',
    'Sweden': 'Švédsko',
    'Switzerland': 'Švajčiarsko',
    'Ukraine': 'Ukrajina',
    'Uruguay': 'Uruguaj',
    //Basketball US Teams
    'Boston': 'Boston',
    'Cleveland': 'Cleveland',
    'Houston': 'Houston',
    'Los Angeles': 'Los Angeles',
    'Orlando': 'Orlando',
    'Portland': 'Portland',
    'San Antonio': 'San Antonio',
    //Basketball Euro Teams
    'Euro Arena': 'Euro Arena',
    'Athens': 'Atény',
    'Real': 'Real',
    'Piraeus': 'Piraeus',
    'Istanbul Blues': 'Istanbul Blues',
    'Fener': 'Fener',
    'Vitoria': 'Vitoria',
    'Tel Aviv Yellows': 'Tel Aviv Yellows',
    'Moscow': 'Moskva',
    'Kaunas': 'Kaunas',
    'Barcelona City': 'Barcelona City',
    'Belgrade': 'Belehrad',
    'Lyon': 'Lyon',
    'Khimki': 'Chimki',
    'Berlin': 'Berlín',
    'St Petersburg': 'Petrohrad',
    'Valencia': 'Valencia',
    //Euro 2020 teams
    'Turkey': 'Turecko',
    'Netherlands': 'Holandsko',
    //Super league
    'Utd': 'United',
    'City': 'City',
    'Liverpool': 'Liverpool',
    'Barcelona': 'Barcelona',
    'Madrid': 'Madrid',
    'Munich': 'Mníchov',
    'Turin': 'Turín',
    'Milan': 'Miláno',
    'Amsterdam': 'Amsterdam',
    'Paris': 'Paríž',
    //NFLA
    'Pittsburgh': 'Pittsburgh',
    'Philadelphia': 'Philadelphia',
    'Denver': 'Denver',
    'New York': 'New York',
    'New England': 'Nové Anglicko',
    'Green Bay': 'Green Bay',
    'San Francisco': 'San Francisco',
    'Miami': 'Miami',
    'Dallas': 'Dallas',
    'Oakland': 'Oakland',
    'Chicago': 'Chicago',
    // market specific words
    'DRAW': 'Remíza',
    'HD': '{0}/Remíza',
    'DA': 'Remíza/{1}',
    'HA': '{0}/{1}',
    'Under 2.5': 'Pod 2,5',
    'Over 2.5': 'Nad 2,5',
    'Under 1.5': 'Pod 1,5',
    'Over 1.5': 'Nad 1,5',
    'Under': 'Pod {0}',
    'Over': 'Nad {0}',
    'HOME': '{0}',
    'AWAY': '{1}',
    'Under 0.5': 'Pod 0,5',
    'Over 0.5': 'Nad 0,5',
    'Under 3.5': 'Pod 3,5',
    'Over 3.5': 'Nad 3,5',
    'Both Score Yes': 'Áno',
    'Both Score No': 'Nie',
    'Home Not to Score': '{0} Neskóruje',
    'Home Exactly 1': '{0} Presne 1',
    'Home Exactly 2': '{0} Exactly 2',
    'Home Exactly 3': '{0} Exactly 3',
    'Home Exactly 4': '{0} Exactly 4',
    'Away Not to Score': '{1} Neskóruje',
    'Away Exactly 1': '{1} Presne 1',
    'Away Exactly 2': '{1} Exactly 2',
    'Away Exactly 3': '{1} Exactly 3',
    'Away Exactly 4': '{1} Exactly 4',
    'Home to Win and both teams to score': '{0} Vyhrá a obaja skórujú',
    'Home to Win to nil': '{0} Vyhrá na nulu',
    'Score draw': 'Remízové skóre',
    '0-0': '0-0',
    '0-1': '0-1',
    '0-2': '0-2',
    '0-3': '0-3',
    '0-4': '0-4',
    '0-5': '0-5',
    '0-6': '0-6',
    '1-0': '1-0',
    '2-0': '2-0',
    '3-0': '3-0',
    '4-0': '4-0',
    '5-0': '5-0',
    '6-0': '6-0',
    '1-1': '1-1',
    '2-2': '2-2',
    '3-3': '3-3',
    '2-1': '2-1',
    '1-2': '1-2',
    '3-1': '3-1',
    '1-3': '1-3',
    '3-2': '3-2',
    '2-3': '2-3',
    '4-1': '4-1',
    '1-4': '1-4',
    '4-2': '4-2',
    '2-4': '2-4',
    '5-1': '5-1',
    '1-5': '1-5',
    '1-0,2-0,2-1': '1-0,2-0,2-1',
    '3-0,3-1,4-0': '3-0,3-1,4-0',
    '1-1,2-2': '1-1,2-2',
    '0-1,0-2,1-2': '0-1,0-2,1-2',
    '0-3,1-3,0-4': '0-3,1-3,0-4',
    'Away to Win and both teams to score': '{1} Vyhrá a obaja skórujú',
    'Away to Win to nil': '{1} Vyhrá na nulu',
    'Home Win By Exactly 1 Goal': '{0} Vyhrá presne o 1 gól',
    'Home Win By Exactly 2 Goals': '{0} Vyhrá presne o 2 góly',
    'Home Win By 3 or more goals': '{0} Vyhrá o 3 alebo viac gólov',
    'Away Win By Exactly 1 Goal': '{1} Win By Exactly 1 Goal',
    'Away Win By Exactly 2 Goals': '{1} Win By Exactly 2 Goals',
    'Away Win By 3 or more goals': '{1} Win By 3 or more goals',
    'Draw With No Goals': 'Remíza bez gólov',
    'Draw With Goals': 'Remíza s gólmi',
    'Any Other': 'Akýkoľvek iný',
    'Home Not To Score': '{0} Neskóruje',
    'Home To Score': '{0} Skóruje',
    'Away Not To Score': '{1} Neskóruje',
    'Away To Score': '{1} To Score',
    'Home': '{0}',
    'No Goal': 'Nepadne gól',
    'Away': '{1}',
    'Home/Home': '{0}/{0}',
    'Home/Draw': '{0}/Remíza',
    'Home/Away': '{0}/{1}',
    'Draw/Home': 'Remíza/{0}',
    'Draw/Draw': 'Remíza/remíza',
    'Draw/Away': 'Remíza/{1}',
    'Away/Home': '{1}/{0}',
    'Away/Draw': '{1}/Remíza',
    'Away/Away': '{1}/{1}',
    'Home and 1-0': '{0} a 1-0',
    'Home and 2-0': '{0} and 2-0',
    'Home and 2-1': '{0} and 2-1',
    'Away and 2-1': '{1} and 2-1',
    'Home and 3-0': '{0} and 3-0',
    'Home and 3-1': '{0} and 3-1',
    'Away and 3-1': '{1} and 3-1',
    'Home and 4-0': '{0} and 4-0',
    'Home and 1-1': '{0} and 1-1',
    'Away and 1-1': '{1} and 1-1',
    'Home and 2-2': '{0} and 2-2',
    'Away and 2-2': '{1} and 2-2',
    'Away and 0-1': '{1} and 0-1',
    'Away and 0-2': '{1} and 0-2',
    'Away and 1-2': '{1} and 1-2',
    'Home and 1-2': '{0} and 1-2',
    'Away and 0-3': '{1} and 0-3',
    'Away and 1-3': '{1} and 1-3',
    'Home and 1-3': '{0} and 1-3',
    'Away and 0-4': '{1} and 0-4',
    'Other': 'Iný',
    'Draw': 'Remíza',
    // Basketball
    '120-124': '120-124',
    '125-129': '125-129',
    '130-134': '130-134',
    '135-139': '135-139',
    '140-144': '140-144',
    '145-149': '145-149',
    '150-154': '150-154',
    '155-159': '155-159',
    '160-164': '160-164',
    '165-169': '165-169',
    '170-174': '170-174',
    '175-179': '175-179',
    'Under 180': 'Pod 180',
    '180-184': '180-184',
    '185-189': '185-189',
    '190-194': '190-194',
    '195-199': '195-199',
    '200-204': '200-204',
    '205-209': '205-209',
    '210-214': '210-214',
    '215-219': '215-219',
    '220-224': '220-224',
    '225-229': '225-229',
    '230-234': '230-234',
    '235-239': '235-239',
    '240-244': '240-244',
    '245-249': '245-249',
    'Over 249': 'Nad 249',
    //American Football
    '26-30': '26-30',
    '31-35': '31-35',
    '36-40': '36-40',
    '41-45': '41-45',
    '46-50': '46-50',
    '25 And Under': 'Pod 26',
    '25 And Under Short': 'Pod 26',
    '51 And Over': 'Nad 50',
    '51 And Over Short': 'Nad 50',
    'and': '&',
    'slash': '/',
    // first down
    FIRST_PLAY: '1st Play',
    SECOND_PLAY: '2nd Play',
    THIRD_PLAY: '3rd Play',
    FOURTH_PLAY: '4th Play',
    FIFTH_PLAY: '5th or More Play',
    FIELD_GOAL: 'Field Goal',
    'PassTD on 1st Play': 'PassTD on 1st Play',
    'PassTD on 2nd Play': 'PassTD on 2nd Play',
    'PassTD on 3rd Play': 'PassTD on 3rd Play',
    'PassTD on 4th Play': 'PassTD on 4th Play',
    'PassTD on or after 5th Play': 'PassTD on or after 5th Play',
    'RunTD on 1st Play': 'RunTD on 1st Play',
    'RunTD on 2nd Play': 'RunTD on 2nd Play',
    'RunTD on 3rd Play': 'RunTD on 3rd Play',
    'RunTD on 4th Play': 'RunTD on 4th Play',
    'RunTD on or after 5th Play': 'RunTD on or after 5th Play',
    'Turnover on 1st Play': 'Turnover on 1st Play',
    'Turnover on 2nd Play': 'Turnover on 2nd Play',
    'Turnover on 3rd Play': 'Turnover on 3rd Play',
    'Turnover on 4th Play': 'Turnover on 4th Play',
    'Turnover on or after 5th Play': 'Turnover on or after 5th Play',
    'Field Goal': 'Field Goal',

    //Game Tabs
    'Football': 'Americký futbal',
    'Matchday': 'Matchday',
    'Basketball': 'Basketbal',
    'Dogs': 'Psy',
    'Motor Racing': 'Motorizmus',
    'Results': 'Výsledky',
    'Horses': 'Dostihy',
    'Soccer': 'Futbal',
    'US Football': 'Americký futbal',
    'Marble Racing': 'Preteky guličiek',
    "Matchday_English": 'Ligové kolo',
    "Matchday_Turkish": "Matchday",
    "Matchday_Greek": 'Ligové kolo Grécko',

    //Game SubTabs
    'Soccer_Euro':'Euro',
    'Soccer_Soccer3_Super_League':'Super Liga',
    'Soccer_Soccer3_Greek_League':'Greek League',
    'Soccer_Super_League':'Super Liga',
    'Soccer_World_Cup':'Majstrovstvá sveta',
    'Soccer_Soccer3_World_Cup':'Majstrovstvá sveta',
    'Horses_Sprints':'Šprinty',
    'Horses_Flats':'Rovinové',
    'Horses_Jumps':'Prekážkové',
    'Basketball_US1':'US',
    'Basketball_US2':'US2',
    'Basketball_Europe':'Európa',
    'Dogs_Flats':'Rovinové',
    'Motor_Racing_Stock_Cars':'Stock Cars',
    'Motor_Racing_Indy_Cars':'Indy Cars',
    'US_Football_NFLA':'NFLA',
    'US_Football_NFL':'NFL',
    'US_Football_Football':'American',
    'Marble_Racing_Marbles':'Marbles',
    'Marble_Racing_Marbles2':'Sand',
    'Marble_Racing_Marbles_Euro':'Soccer',
    'Marble_Racing_Marbles_Halloween':'Halloween',
    "Matchday_English_Matchday_English":"Matchday",
    "Matchday_Turkish_Matchday_Turkish":"Matchday",
    "Matchday_Greek_Matchday_Greek": "Matchday",

    //Racing
    FORECAST: 'Forecast',
    TRICAST: 'Tricast',
    REVERSE_FORECAST: 'Kombinovaný forecast',
    REVERSE_TRICAST: 'Kombinovaný tricast',
    FIRST_ST: '1.',
    SECOND_ND: '2.',
    THIRD_RD: '3.',
    RD: ' ',
    ST: ' ',
    ND: ' ',
    ANY: 'Akýkoľvek',
    TO_WIN: 'Na výhru',
    RACE_CARD: 'RACECARD',
    EACH_WAY: 'Na víťaza/umiestnenie',
    EW: 'Each Way',
    FORECAST_TRICAST: 'Forecast/Tricast',
    EACH_WAY_ODDS_PLACE: 'E/W {0} 1-2',
    EACH_WAY_ODDS_SHOW: 'E/W {0} 1-2-3',
    EXPAND_ALL: 'Rozbaliť',
    COLLAPSE_ALL: 'Zbaliť',
    NUMBER: 'Poradie',
    SORT_BY: 'Triediť podľa',
    BET_SLIP: 'Tiket',
    CLOSE_BET_SLIP: 'Zavri',
    CLOSE_SLIP: 'Zavri',
    PLACED_BETS: 'Podané',
    SETTLED_BETS: 'Vyhodnotené',
    SLIP: 'Tiket',
    OPEN_BETS: 'Nevyhodnotené',
    CLEAR_SELECTIONS: 'Odstrániť tipy',
    ADD_TO_BET_SLIP: 'Pridať na tiket',
    NO_BETS: 'Tipy na tiket pridáte kliknutím na kurz',
    COMBINATION_TRICAST: 'Kombinovaný tricast',
    COMBINATION_FORECAST: 'Kombinovaný forecast',
    TOTAL_STAKE: 'Celkový vklad',
    TOTAL_POTENTIAL_RETURNS: 'Výhra',
    N_A: 'N/A',
    PLACE_BETS: 'Podať tiket',
    REMOVE_ALL: 'Odstrániť všetky',
    POT_RETURNS: 'Výhra',
    RETURNED: 'Vrátené',
    REFUNDED: 'Refundované',
    OK: 'OK',
    WIN_INITIAL: 'V',
    DRAW_INITIAL: 'R',
    LOSE_INITIAL: 'P',

    //Settings
    SETTINGS: 'Nastavenia',
    LANGUAGE: 'Jazyk',
    LAYOUT: 'Rozvrhnutie',
    ODDS: 'Kurz',
    EN_GB: 'Angličtina UK',
    DECIMAL: 'Desatinné',
    FRACTIONAL: 'Zlomkové',
    AMERICAN: 'Americké',
    SIMPLIFIED_DESKTOP: 'This is The main class for the desktop simplified UI',
    SIMPLIFIED_MOBILE: 'This is The main class for the mobile simplified UI',
    SHOW_VIDEO: 'Show Video',

    //Notifications
    ALERT_NOTIFICATION: 'Upozornenie',
    WARNING_NOTIFICATION: 'Varovanie',
    WARNING_NOTIFICATION_REALITY_CHECK: 'Upozornenie',
    INFO_NOTIFICATION: 'Informácia',
    SUCCESS_NOTIFICATION: 'Úspešne',

    SELECTION_REMOVAL: 'Tento výber bude odstránený o ',
    SECONDS: ' sekúnd',
    SECOND: ' sekundu',
    REMOVE_CLOSED_EVENTS: 'Odstrániť uzavreté podujatia',
    SET_VIDEO_ON_FUL_SCREEN: 'Video na celú obrazovku',
    CANCEL: 'Zrušiť',

    //Error codes
    INTERNAL_ERROR: 'Vnútorná chyba',
    OPEN_BETS_WARNING: 'Niektoré alebo všetky otvorené stávky nebolo možné pridať na tiket, pretože boli odohrané v minulých udalostiach,',
    '-32602': 'Jedna alebo viac stávok nebolo uzavretých včas',
    OPEN_BETS_ON_BET_SLIP_LIMIT_REACHED: 'Bol dosiahnutý maximálny počet stávok na tikete. Pred pridaním nových stávok odstráňte alebo podajte stávky',

    '-20000': 'Nedá sa vytvoriť spojenie (kód chyby: -20000)',
    '-20001': 'Nedá sa vytvoriť spojenie (kód chyby: -20001)',
    '-20002': 'Príliš veľa žiadostí (kód chyby: -20002)',
    '-20003': 'Príliš veľa žiadostí (kód chyby: -20003)',
    '-20004': 'Neplatná požiadavka (kód chyby: -20004)',
    '-10000': 'Neplatná požiadavka (kód chyby: -10000)',
    '-10001': 'Neplatná požiadavka (kód chyby: -10001)',
    '-1000': 'Hra bola prerušená. Kontaktujte zákaznícku podporu.',
    '-999': 'Relácia expirovala',
    '-998': 'Hráč suspendovaný',
    '-997': 'Príkaz nie je povolený',
    '-996': 'Chyba spracovania požiadavky (kód chyby: -996)',
    '-995': 'Chyba spracovania požiadavky (kód chyby: -995)',
    '-994': 'Spojenie prerušené so serverom, stávka nebola podaná',
    '-980': 'Chyba spracovania požiadavky (kód chyby: -980)',
    '-979': 'Chyba spracovania požiadavky (kód chyby: -979)',
    '-978': 'Na vykonanie tejto transakcie nie je dostatok finančných prostriedkov.',
    '-977': 'Kontrola bdelosti zlyhala',
    '-976': 'Operácia s peňaženkou je dočasne zablokovaná',
    '-975': 'Prekročený limit vkladu',
    '-974': 'Prekročený limit prehier',
    '-973': 'Nie je nastavený limit',
    '-972': 'Chyba pri zodpovednom hraní',
    '-971': 'Operácia s peňaženkou zlyhala',
    '-970': 'Transakcia v peňaženke bola odmietnutá',
    '-969': 'Chyba komunikácie s peňaženkou.',
    '-968': 'Chyba transakcie s peňaženkou',
    '-967': 'Neúspešné overenie',
    '-966': 'Hranica vysokej výhry bola prekročená',
    '-965': 'Neplatné parametre',

    // BET LIMITS ALERTS
    BET_STAKE_OUT_OF_LIMITS_MESSAGE: 'Jedna alebo viac stávok nie je platných. Minimálny vklad: {0}, maximálny vklad: {1}. Pred odoslaním tiketu prosím opravte Váš výber.',
    LIST_BET_STAKE_OUT_OF_LIMITS_MESSAGE: 'Stake limits on {0} are Min {1} & Max {2}',
    BET_POTENTIAL_RETURNS_OUT_OF_LIMITS_MESSAGE: 'Potenciálna výhra jednej alebo viacerých stávok presahuje maximálnu možnú výhru {0}. Pred odoslaním tiketu prosím opravte Váš výber',
    BET_NON_DIVISIBLE_MESSAGE: 'One or more bets not divisible by {0} . Please fix this before placing your bets.',
    SINGLE_BET_COMMIT_MESSAGE: 'You cannot place multiple single bets',
    REALITY_CHECK_WARNING_MESSAGE_LINE_1: 'The bet(s) you are placing are over {0}.',
    MIN_STAKE_REALITY_CHECK_WARNING_MESSAGE_LINE_1: 'The bet(s) you are placing are under {0}',
    REALITY_CHECK_WARNING_MESSAGE_LINE_2: 'Is this OK',
    REALITY_CHECK_TOTAL_STAKE_SINGLE_EVENT_WARNING: 'The maximum amount of {0} has been staked. Please select a different event',

    //SIMPLIFIED UI
    TOTAL_BETS: 'Celková stávka',
    PLACE_YOUR_BETS: 'Uzatvorte svoje stávky',
    RACE_START: 'Štart pretekov',
    RACE_START_TIME: 'Čas štartu',
    BET_SUMMARY: 'Zhrnutie',
    NO_BETS_RESUME: 'Na aktuálnu udalosť neboli uzatvorené žiadne stávky',
    LIVE: 'LIVE',
    RACERS: 'Pretekári',
    SELECTION: 'Tipy',
    DATE_LOCATION: 'Udalosť',
    STAKE: 'Vklad',
    BET_TYPE_STAKE: 'Typ stávky / Vklad',
    POTENTIAL_RETURNS: 'Výhra',
    BET_HISTORY: 'História stávok',
    BET_HISTORY_LABEL: 'Pre zobrazenie ďalších položiek, kliknite na tlačidlo História stávok',
    FILTER_WINS: 'Filter výhier',
    NEXT_RACE: 'Ďalšie preteky',
    WIN: '1',
    PLACE: '1-2',
    SHOW: '1-3',
    EXACTA: 'Forecast',
    TRIFECTA: 'Tricast',
    NO_WIN: 'Nevýherný',
    WON: 'Výhra',
    LOST: 'Prehra',
    CURRENT_RACE: 'Aktuálne preteky',
    BOX: 'BOX',
    TO: 'do',
    PAYS: 'pays',
    TRIFECTA_BOX: 'Kombinovaný tricast',
    EXACTA_BOX: 'Kombinovaný forecast',
    FINISH_YOUR_BETS: 'Ukončite Vaše stávky',
    SELECT_YOUR_BET_BELOW: 'Tipy na tiket pridáte kliknutím na kurz',
    BET: 'stávka',
    REMOVED: 'odstránený',
    RESULT: 'Výsledok',
    GOALS: 'Góly',
    NO_MORE_BETS: 'Príjem stávok pre udalosť uplynul',
    EVENT_LIVE_MSG_LINE_1: 'Udalosť práve prebieha',
    EVENT_LIVE_MSG_LINE_2: 'Vyššie si vyber z udalostí,',
    EVENT_LIVE_MSG_LINE_3: 'ktoré budú nasledovať',
    NO_FUTURE_EVENTS: 'Žiadne nasledujúce udalosti',
    AUTHENTICATION_REQUIRED: 'Prosím, prihláste sa pre pokračovanie',
    GAME_DISABLED: 'Udalosť nedostupná',
    GAME_DISABLED_MESSAGE: 'Prosím, kontaktujte zákaznícku podporu',
    VOIDED: 'Zrušené',
    HELP: 'Pomoc',
    LAST_RESULTS: 'Predchádzajuce výsledky',
    NO_LAST_RESULTS: 'Predchádzajuce výsledky nie sú k dispozícii',
    PREVIOUS_RESULTS: 'Predchádzajúce výsledky',
    OFFENSE_PREVIOUS_RESULTS: 'Predchádzajuce výsledky útoku',
    DEFENSE_PREVIOUS_RESULTS: 'Predchádzajuce výsledky obrany',
    NO_LUCK: 'Smola',
    THIS_TIME: 'Tentokrát',
    LOOK_FOR_THE_NEXT: 'Nasleduje ďalšia',
    SCHEDULED_EVENT: 'plánovaná udalosť',
    LOOK_FOR_THE: 'Nasledujú',
    NEXT_SCHEDULED: 'ďalšie naplánované',
    EVENT: 'udalosti',
    RETURNS: 'VÝHRA',
    NEXT: 'Ďalšie',
    FUTURE: 'Budúce',
    PLAYING: 'Hranie',

    //MESSAGE BAR
    ON: 'Prebieha',
    MB_RACE_ON: 'Prebieha',
    MB_RACE_WIN: '1',
    MB_RACE_PLACE: '1-2',
    MB_RACE_SHOW: '1-3',
    MB_RACE_TRIFECTA_BOX: 'Kombinovaný tricast',
    MB_RACE_EXACTA_BOX: 'Kombinovaný forecast',
    MB_RACE_EXACTA: 'forecast',
    MB_RACE_TRIFECTA: 'tricast',
    MB_FOOTBALL_ON: 'Prebieha',

    // DESKTOP UI
    ADVERTISING_SPACE: 'ADVERTISING SPACE',
    CLEAR_LAST: 'Vymazať posledné',
    CLEAR_ALL: 'Vymazať všetko',
    ACTIVE_BETS: 'Aktívne stávky',
    ONLY_SHOW_WINS: 'Zobraziť iba výhry',
    MORE: 'Viac',
    BETS: 'Stávky',
    LOADING: 'Načítava sa',
    BET_SELECTION_MESSAGE: 'Výber uskutočníte kliknutím na kurz',

    // BUTTONS
    SIMPLE: 'simple',
    EXOTIC: 'exotic',
    UNDO: 'undo',
    CLEAR: 'clear',
    HISTORY: 'história',

    MARKETS: 'Stávkové príležitosti',
    MAIN: 'Hlavné',
    VS: 'vs',
    AT: '@',
    SCORE: 'skóre',
    DEFENDS: '(Defends) at',
    ATTACKS: '(Attacks) at',
    DETAILS: 'Details',
    NO_GOALS: 'Bez gólov',

    MAX_WINNINGS_REACHED: 'Dosiahnutý limit výhier',
    MAX_WINNINGS_REACHED_TEXT: 'Aktuálna stávka presiahne maximálnu hodnotu výhry {0}. Maximálna povolená hodnota vkladu pre túto stávku je {1}.',
    NO_CONNECTION_TITLE: 'Strata spojenia',

    NO_CONNECTION_TITLE_TEXT: 'Spojenie so serverom je prerušené, uistite sa, že máte stabilné sieťové pripojenie a obnovte stránku. Ak problém pretrváva, kontaktujte podporu.',
    PLAYER_LOGGED_OTHER_PLACE_TITLE_TEXT: 'Pripojenie prerušené, používateľ sa pripojil dvakrát',
    BET_CONFIRMED_TEXT:'none',
    TAX_NOTIFICATION_TEXT:'none',
    //Event title names
    //Football
    'THE MANOR GROUND': 'Berners Stadium',
    'METRO STADIUM': 'Metro Stadium',

    //Horses Sprints
    'HorsesSprints': 'Wetmore Sprints',
    'Showell Park': 'Showell Park',
    '2FurlongHorses': 'Wetmore Sprints',
    'Sandringham Flats': 'Sandringham Flats',
    'Princess Parkway': 'Princess Parkway',

    //BasketBall
    'Virtual Arena': 'Virtual Arena',
    'Inspired Arena': 'Inspired Arena',
    //Horses Jumps
    'HorsesJumps': 'Dostihy prekážky',

    //Dogs
    'DogFlat': 'Barking Green',
    'Dogs2': 'Barking Green',
    'Victoria Park': 'Victoria Park',
    'Jennison Stadium': 'Jennison Stadium',
    "Dogs_City": "Statické Kurzy",

    //Motor Racing
    'Circuit': 'Circuit',

    //Speedway Park
    'Speedway Park': 'Inspired Raceway',
    'Auto Raceway': 'Auto Raceway',

    'NO_CONNECTION_TO_VIRGO': 'Strata spojenia',
    'NO_CONNECTION_TO_VIRGO_TEXT': 'Prosím obnovte stránku a prihláste sa.',
    'BROWSER_NOT_SUPPORTED_DETAILS': 'Váš aktuálny prehliadač nie je podporovaný. Použite jeden z nasledujúcich prehliadačov Chrome, Firefox alebo Safari.',
    'BROWSER_NOT_SUPPORTED': 'Prehliadač nie je podporovaný',
    'DOWNLOAD_CHROME': 'Stiahnuť Chrome',
    'DOWNLOAD_FIREFOX': 'Stiahnuť Firefox',
    'v': 'V',
    '1': '1',
    'x': 'X',
    '2': '2',
    'at': '@',
    '+10.5': '+10.5',
    '+15.5': '+15.5',
    '+5.5': '+5.5',
    '-10.5': '-10.5',
    '-15.5': '-15.5',
    '-5.5': '-5.5',
    'Over 219.5': 'Nad 219,5',
    'Under 219.5': 'Pod 219,5',
    'Over 214.5': 'Nad 214,5',
    'Under 214.5': 'Pod 214,5',
    'Over 209.5': 'Nad 209,5',
    'Under 209.5': 'Pod 209,5',
    'Over 144.5': 'Nad 144,5',
    'Under 144.5': 'Pod 144,5',
    'Over 149.5': 'Nad 149,5',
    'Under 149.5': 'Pod 149,5',
    'Over 154.5': 'Nad 154,5',
    'Under 154.5': 'Pod 154,5',
    'Over 159.5': 'Nad 159,5',
    'Under 159.5': 'Pod 159,5',
    'Over 164.5': 'Nad 164,5',
    'Under 164.5': 'Pod 164,5',
    'Rolling Downs': 'Rolling Downs',
    'FINISHING_ORDER': 'Forecast/Tricast',
    'FORECAST_MARBLE': 'Forecast',
    'TRICAST_MARBLE': 'Tricast',
    'REVERSE_FORECAST_MARBLE': 'Kombinovaný Forecast',
    'REVERSE_TRICAST_MARBLE': 'Kombinovaný Tricast',
    'TO_WIN_MARBLE': '1',
    'PLACE_MARBLE': '1-2',
    'SHOW_MARBLE': '1-3',
    'MARBLE': 'Preteky guličiek',
    'Rumble Turns': 'Rumble Turns',
    'Maple Downs': 'Maple Downs',

    //Header
    'BALANCE': 'Zostatok',
    'DATE_FORMAT': 'DD/MM/YYYY HH:mm',
    'WINS_THE_GAME': 'Vyhráva zápas',
    'Any': 'M',
    "BET_BOTH": 'Vsaďte oboje',
    //Matchday
    "betSlip_Matchday_English": 'Ligové kolo Anglicko',
    "betSlip_Matchday_Turkish": 'Ligové kolo Turecko',
    "betSlip_Matchday_Greek": 'Ligové kolo Grécko',
    "betSlip_Soccer": 'Futbal',
    "betSlip_Horses": 'Dostihy',
    "betSlip_Basketball": 'Basketbal',
    "betSlip_Dogs": 'PSY',
    "betSlip_Motor Racing": 'Motorizmus',
    "betSlip_US Football": 'Americký futbal',
    "betSlip_Marble Racing": 'Preteky guličiek',
    "POS": 'POZ',
    "TEAM": 'TÍM',
    "P": 'B',
    "W": 'V',
    "D": 'R',
    "L": 'P',
    "F": 'SG',
    "A": 'OG',
    "PTS": 'B',
    "LEAGUE TABLE": 'LIGOVÁ TABUĽKA',
    "TREND": 'FORMA',

    //Matchday English Teams
    "Matchday_Islington": "ISL",
    "Matchday_City": "CTY",
    "Matchday_Palace": "PAL",
    "Matchday_Chelsea": "CHE",
    "Matchday_Southampton": "SOU",
    "Matchday_Wolverhampton": "WOL",
    "Matchday_Sheffield": "SHE",
    "Matchday_Leicester": "LEI",
    "Matchday_Newcastle": "NEW",
    "Matchday_Tottenham": "TOT",
    "Matchday_West Ham": "WHA",
    "Matchday_United": "UTD",
    "Matchday_Leeds": "LEE",
    "Matchday_Liverpool": "LIV",
    "Matchday_Everton": "EVE",
    "Matchday_Aston": "AST",

    //Matchday Turkish Teams
    "Matchday_Basaksehir": "BAS",
    "Matchday_Trabzon": "TRZ",
    "Matchday_Besiktas": "BKS",
    "Matchday_Sivas": "SIV",
    "Matchday_Alanya": "ALA",
    "Matchday_Galata": "GLS",
    "Matchday_Fenerbahce": "FRB",
    "Matchday_Gazientep": "GAZ",
    "Matchday_Antalya": "ANT",
    "Matchday_Kasimpasa": "KAS",
    "Matchday_Goztepe": "GOZ",
    "Matchday_Gencler": "ESK",
    "Matchday_Konya": "BUR",
    "Matchday_Rize": "RIZ",
    "Matchday_Malatya": "MAL",
    "Matchday_Kayseri": "KAY",

    //Matchday Greek Teams
    "Matchday_Dikefalos Vora": "ΔΙΚ",
    "Matchday_Erithrolefkoi": "ΘΡΥ",
    "Matchday_Enosi": "ΕΝΩ",
    "Matchday_Peristeri": "ΠΕΡ",
    "Matchday_Prasinoi": "ΠΡΑ",
    "Matchday_Kitrinoi Vora": "ΚΙΤ",
    "Matchday_Nea Smirni": "ΣΜΥ",
    "Matchday_Xanthi": "ΞΑΝ",
    "Matchday_Tripoli": "ΤΡΙ",
    "Matchday_Agrinio": "ΑΓΡ",
    "Matchday_Larisa": "ΛΑΡ",
    "Matchday_Lamia": "ΛΑΜ",
    "Matchday_Ioannina": "ΙΩΑ",
    "Matchday_Iraklio": "ΗΡΑ",
    "Matchday_A.O. Rizoupolis": "ΡΙΖ",
    "Matchday_Volos": "ΒΟΛ",

 //Soccer3 Greek Teams
    "Dikefalos Vora":"ΔΙΚ",
    "Erithrolefkoi":"ΘΡΥ",
    "Enosi":"ΕΝΩ",
    "Peristeri":"ΠΕΡ",
    "Prasinoi":"ΠΡΑ",
    "Kitrinoi Vora":"ΚΙΤ",
    "Nea Smirni":"ΣΜΥ",
    "Xanthi":"ΞΑΝ",
    "Tripoli":"ΤΡΙ",
    "Agrinio":"ΑΓΡ",
    "Larisa":"ΛΑΡ",
    "Lamia":"ΛΑΜ",
    "Ioannina":"ΙΩΑ",
    "Iraklio":"ΗΡΑ",
    "A.O. Rizoupolis":"ΡΙΖ",
    "Volos":"ΒΟΛ",

    "Dortmund": "Dortmund",
    "Chelsea": "Chelsea",
    "Porto": "Porto",
    "Rome": "Rome",
    "Benfica": "Benfica",
    "Celtic": "Celtic",
    "United": "United",
    UNDER_OVER_MATCHDAY: 'Nad/Pod',
    UNDER_OVER_05_SHORT: '0,5',
    UNDER_OVER_15_SHORT: '1,5',
    UNDER_OVER_25_SHORT: '2,5',
    UNDER_OVER_35_SHORT: '3,5',
    UNDER_SHORT: 'P',
    OVER_SHORT: 'N',
    "FULL TIME": 'Koniec',
    "FT": 'FT',
    "System": 'Systém',
    "x1": "(x1)",
    "Multiplier": 'Opakuj stávku',
    "Main markets": 'Kurzová ponuka',
    "4RANDOM": "4 náhodných",
    "6RANDOM": "6 náhodných",
    "8RANDOM": '8 náhodných',
    "8FAVS": '8 favoritov',
    "QUICK_SELECT": 'Náhodný výber',
    "UNDER": 'POD',
    "OVER": 'NAD',
    "UNDER_OVER_2_5": 'Nad/Pod 2,5',
    "UNDER_OVER_3_5": 'Nad/Pod 3,5',
    "MATCH_RESULT": 'Výsledok zápasu',
    "YES": 'Áno',
    "NO": 'Nie',
    "REALITY_CHECK_WARNING_YES": 'Áno',
    "REALITY_CHECK_WARNING_NO": 'Nie',
    "ACCUMULATOR": 'Kumulatívna stávka',
    "+1G": '+1G',
    "Single": 'Sólo',
    "Doubles": '2 akum. tipy',
    "Trebles": '3 akum. tipy',
    "Four Folds": "4 akum. tipy",
    "Five Folds": "5 akum. tipov",
    "Six Folds": "6 akum. tipov",
    "Seven Folds": "7 akum. tipov",
    "Eight Folds": "8 akum. tipov",
    "MD": "LK{0}",
    "MATCH": 'Zápas',
    "INVALID_ACCA": 'Zvýraznené položky sa nemôžu kombinovať',
    "INVALID_ODDS": 'Hodnota kurzu je príliš vysoká. Zmeňte svoj výber',
    "INVALID_ACCA_MORETHAN_8": 'Viacnásobné stávky nemôžu obsahovať viac ako 8 výberov z jedného zápasu',

    // Accumulator Boost
    "ACCUMULATOR_BOOST": 'Akumulačný bonus',
    "Bonus_Info": 'Bonus {0}%',
    "+": "+",
    "Bonus_Value": 'Vrátane bonusu {0}',
    "ACCUMULATOR_INFO": 'Ak je stávka výherná, výhra sa zvyšuje o bonus vo výške {0}% - {1}%. Hodnota bonusu závisí od počtu tipov na tikete.',
    "BET_TYPE": 'Typ stávky',
    "BOOST": 'Navýšenie',
    "BOOST_PERCENTAGE": '{0}%',
    "BOOST_BONUS_START": '{0} a viac tipov na kumulovanej stávke navyšuje výhru',
    "BOOST_BONUS_UPGRADE": 'Pre zvýšenie bonusovej čiastky pridajte ďalší tip',
    "BOOST_BONUS_MAX": 'Získali ste maximálny akumulačný bonus',
    "Marbles_Euro_1": "Belgicko",
    "Marbles_Euro_2": "Chorvátsko",
    "Marbles_Euro_3": "Dánsko",
    "Marbles_Euro_4": "Anglicko",
    "Marbles_Euro_5": "Francúzsko",
    "Marbles_Euro_6": "Nemecko",
    "Marbles_Euro_7": "Taliansko",
    "Marbles_Euro_8": "Holandsko",
    "Marbles_Euro_9": "Portugalsko",
    "Marbles_Euro_10": "Španielsko",
    "Short_Over": "Nad {0}",
    "Short_Under": "Pod {0}",
    "DEMOPLAY_NOTIFICATION_MESSAGE_LINE_1": "Pre hru za peniaze je potrebné sa prihlásiť",
    "DEMOPLAY_NOTIFICATION_MESSAGE_LINE_2": " ",
    "DEMOPLAY_NOTIFICATION_DISMISS": "Hrať pre zábavu",
    "DEMOPLAY_NOTIFICATION_OK": "OK",
    "Matchday_Moroccan":"Matchday Moroccan",
    "Matchday_Moroccan_Matchday_Moroccan":"Matchday Moroccan",
    "betSlip_Matchday_Moroccan":"Matchday Moroccan",

    //Matchday Moroccan Teams
    "Matchday_Casa Reds":"WYD",
    "Matchday_Casa Greens":"RAJ",
    "Matchday_Fès":"FES",
    "Matchday_El Jadida":"ELJ",
    "Matchday_Berkane":"BKN",
    "Matchday_Feth":"FTH",
    "Matchday_FARabat":"FAR",
    "Matchday_Mohammedia":"MOH",
    "Matchday_Soualem":"SLM",
    "Matchday_Khouribga":"KHO",
    "Matchday_Tanger":"TAN",
    "Matchday_Agadir":"AGA",
    "Matchday_Berrechid":"BER",
    "Matchday_Oujda":"OUJ",
    "Matchday_Safi":"SAF",
    "Matchday_Oued Zem":"ODZ",
    "Matchday_Tétouan":"TET",
    "Matchday_Touarga":"TRG",
    "Matchday_Beni Mellal":"BNM",
    "Matchday_Stade Maroc":"STM",
    "Matchday_Zemamra":"ZMR",

    "Soccer_Soccer3_Moroccan_League":"Moroccan",
    //Soccer3 Moroccan Teams
    "Casa Reds":"Casa Reds",
    "Casa Greens":"Casa Greens",
    "Fès":"Fès",
    "El Jadida":"El Jadida",
    "Berkane":"Berkane",
    "Feth":"Feth",
    "FARabat":"FARabat",
    "Mohammedia":"Mohammedia",
    "Soualem":"Soualem",
    "Khouribga":"Khouribga",
    "Tanger":"Tanger",
    "Agadir":"Agadir",
    "Berrechid":"Berrechid",
    "Oujda":"Oujda",
    "Safi":"Safi",
    "Oued Zem":"Oued Zem",
    "Tétouan":"Tétouan",
    "Touarga":"Touarga",
    "Beni Mellal":"Beni Mellal",
    "Stade Maroc":"Stade Maroc",
    "Zemamra":"Zemamra",
    "QUICK_FILL": "Quick Fill",
    "MAD" : "{0} MAD",

    //Matchday Belgium
    "Matchday_Belgium": "Matchday",
    "Matchday_Belgium_Matchday_Belgium": "Matchday",
    "betSlip_Matchday_Belgium": "Matchday Belgium",
    //Matchday Belgium Teams
    "Matchday_Saint-Gilles": "SAI",
    "Matchday_Club": "CLU",
    "Matchday_Anderlecht": "AND",
    "Matchday_Antwerp": "ANT",
    "Matchday_Gent": "GEN",
    "Matchday_Mechelen": "MEC",
    "Matchday_Charleroi": "CHA",
    "Matchday_Genk": "GNK",
    "Matchday_Brugge": "BRU",
    "Matchday_Sint-Truiden": "SIN",
    "Matchday_Leuven": "LEU",
    "Matchday_Kortrijk": "KOR",
    "Matchday_Liege": "LIE",
    "Matchday_Oostende": "OOS",
    "Matchday_Waregem": "WAR",
    "Matchday_Eupen": "EUP",
    "Matchday_Seraing": "SER",

    //BonusBet
    "Gift_for_You_Heading" :"A GIFT FOR YOU",
    "Gift_for_You_Content": "Congratulations! You have promotional offers to redeem.",
    "View_Offers" : "VIEW OFFERS",
    "Do_Not_Show_MSG": "DO NOT SHOW AGAIN",
    "MY_OFFERS" : 'MY OFFERS',
    "SELECT_OFFER" : 'SELECT YOUR OFFER',
    "NO_OFFER" : 'THERE ARE NO ACTIVE OFFERS',
    "CHOOSE_BET": 'CHOOSE BET',
    "Opt_In": 'OPT IN',
    "Key_Terms_Heading" :"KEY TERMS",
    "No_Thanks" : "NO THANKS",
    "PROMO_BET": 'PROMO BET',
    "Time_To_Bet": "TIME TO BET",
    "OPTED_IN_MSG": "THANKS, YOU HAVE OPTED IN",
    "EXP": "Exp.",
    "SELECT": "Select",
    "DEMO_SITE_PROMO_NOT_AVAILABLE": "This demo site does not currently offer any promos. Please log in/register to access current offers. !",
    "Horses_US_Horses": "USA",

    //cricket
    "Cricket" : "Kriket",
    "Cricket_International": "Medzinárodný",
    "betSlip_Cricket": "Kriket",
    //circket teams
     "Australia":"Australia",
     "India":"India",
     "Pakistan":"Pakistan",
     "West Indies" : "West Indies",
     "Sri Lanka":"Sri Lanka",
     "New Zealand":"New Zealand",
     "South Africa":"South Africa",
     "Australia_short":"AUS",
     "WestIndies_short" : "WI",
     "SriLanka_short":"SRI",
     "NewZealand_short":"NZL",
     "India_short":"IND",
     "SouthAfrica_short":"RSA",
     "Pakistan_short":"PAK",
     "England_short": "ENG",
     "Tie":"Tie",
    //cricket markets
     "MATCH_WINNER":"Víťaz zápasu",
     "TOTAL_SIXES_IN_MATCH":"Celkový počet zápasov 6",
     "TOTAL_SIXES_IN_MATCH_SHORT": "Pod 1.5",
     "TOTAL_FOUR_IN_MATCH":"Celkový počet zápasov 4",
     "TOTAL_BOUNDARIES_IN_MATCH":"Hranice zápasu celkovo",
     "FIRST_TEAM_TOTAL_RUNS":"{0} Celkový počet behov",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL":"{0} Behy mimo prvého odovzdania",
     "FIRST_TEAM_WICKET_LOST":"{0} Minutá bránka",
     "FIRST_TEAM_WICKET_LOST_DISMISSAL_TYPE": "{0} Prvý spôsob pre typ prepustenia",
     "FIRST_TEAM_RUN_OFF_FIRST_BALL_OVER_UNDER_05_SHORT": "0.5",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_15_SHORT": "1.5",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_25_SHORT": "2.5",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_35_SHORT": "3.5",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_UNDER_OVER":"{0} Behy mimo PRVEJ loptičky nad/pod",
     "FIRST_TEAM_RUN_OFF_FIRST_BALL_OVER_UNDER_05": "{0} Behy mimo PRVEJ loptičky nad/pod",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_15": "{0} Behy mimo PRVEJ loptičky nad/pod",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_25": "{0} Behy mimo PRVEJ loptičky nad/pod",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_35": "{0} Behy mimo PRVEJ loptičky nad/pod",
     "Caught" : "Chytené",
     "Bowled":"Bowled",
     "LBW":"LBW",
     "No Wicket":"Žiadna bránka",
     "OverZeroPointFive": "Nad 0.5",
     "UnderZeroPointFive": "Pod 0.5",
     "OverOnePointFive": "Nad 1.5",
     "UnderOnePointFive": "Pod 1.5",
     "OverTwoPointFive": "Nad 2.5",
     "UnderTwoPointFive": "Pod 2.5",
     "OverThreePointFive": "Nad 3.5",
     "UnderThreePointFive": "Pod 3.5",
     "Yes": "Áno",
     "No":"Nie",
     "FINAL_SCORE":"Final Score",
      OVER_145: 'Nad 14.5',
      UNDER_145: 'Pod 14.5',
      DRAW_Cricket: "DRAW",
       //TENNIS
    TOTAL_POINTS:"Celkový počet bodov",
    HANDICAP_TENNIS: "Handicap",
    Scotland :"Scotland",
    USA: "USA",
    Tennis_International: "Medzinárodný",
    betSlip_Tennis: "Tenis",
    "Win By 2 or 3": "Výhra o najviac 3 body",
    "Win By 4 or 5": "Výhra o 4 alebo 5 bodov",
    "Win By 6 or 7": "Výhra o 6 alebo 7 bodov",
    "Tennis": "Tenis",
   //baseball
    WINNER : "VÍŤAZ",
    TOTAL_HOME_RUNS_UNDER_OVER: "CELKOVÝ POČET HOMERUNOV VYŠŠÍ/NIŽŠÍ",
    TOTAL_HOME_RUNS:  "CELKOVÝ POČET HOMERUNOV PRESNÝ",
    WINNER_AND_TOTAL_HOME_RUNS_OVER_UNDER:"CELKOVÝ POČET HOMERUNOV VYŠŠÍ/NIŽŠÍ 5,5",
    WINNER_AND_TOTAL_HOME_RUNS_OVER_UNDER_SHORT:"Víťaz a celková počet HR VYŠŠÍ/NIŽŠÍ 5,5",
    BATTER1_HOME_RUNS: "{0} HOMERUNY",
    BATTER2_HOME_RUNS: "{1} HOMERUNY",
    Baseball_HR_ShootOut_Legends: " Legendy duelov homerunov",
    Baseball_HR_ShootOut_Legends_SHORT: "HR duel",
    "Baseball": "Bejzbal",
    "betSlip_Baseball": "Bejzbal",
    "Player 1 AND OVER_5_5":"{0} a vyšší ako 5,5",
    "Player 2 AND OVER_5_5":"{0} a vyšší ako 5,5",
    "Player 1 AND UNDER_5_5":"{0} a nižší ako 5,5",
    "Player 2 AND UNDER_5_5":"{0} a nižší ako 5,5",
    "Draw AND OVER_5_5":"Remíza a vyšší ako 5,5",
    "Draw AND UNDER_5_5":"Remíza a nižší ako 5,5",
    "HOME RUNS":"{0} HOMERUNY",
    "Next Fixtures":"Next Fixtures",
    "MATCH_IN_PROGRESS": "Match In Progress",
    "Matchday_Light_English": "Matchday Light",
    "Matchday_Light_English_Matchday_Light_English": "English League",
    "betSlip_Matchday_Light_English": "Matchday Light",
     //NFL
    'Cardinals' : 'Cardinals',
    'Falcons' : 'Falcons',
    'Ravens' : 'Ravens',
    'Bills' : 'Bills',
    'Panthers' : 'Panthers',
    'Bears' : 'Bears',
    'Bengals' : 'Bengals',
    'Browns' : 'Browns',
    'Cowboys' : 'Cowboys',
    'Broncos' : 'Broncos',
    'Lions' : 'Lions',
    'Packers' : 'Packers',
    'Texans' : 'Texans',
    'Colts' : 'Colts',
    'Jaguars' : 'Jaguars',
    'Chiefs' : 'Chiefs',
    'Raiders' : 'Raiders',
    'Chargers' : 'Chargers',
    'Rams' : 'Rams',
    'Dolphins' : 'Dolphins',
    'Vikings' : 'Vikings',
    'Patriots' : 'Patriots',
    'Saints' : 'Saints',
    'Giants' : 'Giants',
    'Jets' : 'Jets',
    'Eagles' : 'Eagles',
    'Steelers' : 'Steelers',
    '49ers' : '49ers',
    'Seahawks' : 'Seahawks',
    'Buccaneers' : 'Buccaneers',
    'Titans' : 'Titans',
    'Commanders' : 'Commanders',
    'NEW' : 'New',
    //Soccer_Soccer3_Turkish_League team names and game name
    "Soccer_Soccer3_Turkish_League": "Turkish League",
    "Basaksehir": "BAS",
    "Trabzon": "TRZ",
    "Besiktas": "BKS",
    "Sivas": "SIV",
    "Alanya": "ALA",
    "Galata": "GLS",
    "Fenerbahce": "FRB",
    "Gazientep": "GAZ",
    "Antalya": "ANT",
    "Kasimpasa": "KAS",
    "Goztepe": "GOZ",
    "Gencler": "ESK",
    "Konya": "BUR",
    "Rize": "RIZ",
    "Malatya": "MAL",
    "Kayseri": "KAY",

    //NBA 
  "Basketball_NBA": "NBA",
  "Atlanta Hawks": "Atlanta Hawks",
  "Boston Celtics": "Boston Celtics",
  "Brooklyn Nets": "Brooklyn Nets",
  "Charlotte Hornets": "Charlotte Hornets",
  "Chicago Bulls": "Chicago Bulls",
  "Cleveland Cavaliers": "Cleveland Cavaliers",
  "Dallas Mavericks": "Dallas Mavericks",
  "Denver Nuggets": "Denver Nuggets",
  "Detroit Pistons": "Detroit Pistons",
  "Golden State Warriors": "Golden State Warriors",
  "Houston Rockets": "Houston Rockets",
  "Indiana Pacers": "Indiana Pacers",
  "Los Angeles Clippers": "Los Angeles Clippers",
  "Los Angeles Lakers": "Los Angeles Lakers",
  "Memphis Grizzlies": "Memphis Grizzlies",
  "Miami Heat": "Miami Heat",
  "Milwaukee Bucks": "Milwaukee Bucks",
  "Minnesota Timberwolves": "Minnesota Timberwolves",
  "New Orleans Pelicans": "New Orleans Pelicans",
  "New York Knicks": "New York Knicks",
  "Oklahoma City Thunder": "Oklahoma City Thunder",
  "Orlando Magic": "Orlando Magic",
  "Philadelphia 76ers": "Philadelphia 76ers",
  "Phoenix Suns": "Phoenix Suns",
  "Portland Trail Blazers": "Portland Trail Blazers",
  "Sacramento Kings": "Sacramento Kings",
  "San Antonio Spurs": "San Antonio Spurs",
  "Toronto Raptors": "Toronto Raptors",
  "Utah Jazz": "Utah Jazz",
  "Washington Wizards": "Washington Wizards",
  "TOTALPOINTS": "TOTAL POINTS"

};


// WEBPACK FOOTER //
// ./src/localization/sk_SK.js